<template>
	<div>
         <div class="form-group">
            <label>Fichier(s) à uploader: </label> 
            <dropzone id="dropzone"
                    ref="dropzone"
                    :options="dropzoneConfig"
                    @vdropzone-success="uploadSuccess"
            >
            </dropzone>
        </div>
        <button class="btn btn-success" type="button" @click="importFiles">Importer</button>
        <!-- <button class="btn btn-success" type="button" @click="importFiles(false)">Importer sans mettre à jour les recordId</button> -->
 	</div>
</template>

<script>
    import Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    export default {
        components: {
            Dropzone
        },
        computed: {
        },
        methods: {
            uploadUrl: function() {
                return this.$store.state.baseUrl + '/admin/person/' + this.modalPerson.id + '/file-upload/' + (this.updateRecordId ? 1 : 0);
            },
            importFiles(updateRecordId = true) {
                this.updateRecordId = updateRecordId;
                this.$refs.dropzone.processQueue();
            },
            uploadSuccess(file, response) {
                this.$emit('importSuccess', response.notImported);
                this.$refs.dropzone.removeAllFiles()
            }
        },
        props: ['modalPerson'],
        data: function()  {
            return {
                requiredName: false,
                updateRecordId: true,
                dropzoneConfig: {
                    url: this.uploadUrl,
                    autoProcessQueue: false,
                    addRemoveLinks: true,
                    acceptedFiles: 'text/*,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    uploadMultiple: true,
                    paramName: 'files',
                    headers: this.$store.state.headers
                }
            };
        }
    };
</script>
